import React, {useEffect, useState,useRef} from 'react'
import {connect} from 'react-redux'
import {Button, Col, Form, FormGroup, Input, Modal, ModalBody, ModalFooter, ModalHeader, Row, UncontrolledTooltip} from "reactstrap";
import {Archive} from "react-bootstrap-icons";
import EditButton from "./EditButton";
import DeleteButton from "./DeleteButton";
import Select from "react-select";
import OPKProceduralneStatystykaMedForm from 'views/LoggedUserPages/DataImport/Forms/OPKProceduralneStatystykaMedForm';
import ReportButtons from 'components/common/ReportButtons'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Document, Packer, Table, TableRow, TableCell, Paragraph, TextRun, WidthType, AlignmentType, VerticalAlign, convertMillimetersToTwip } from 'docx';

// import { getMaterials, postMaterial } from 'actions/procedureDefActions';

const PersonalProcedurePricing = ({editProcedureStaff, deleteProcedureStaff,postProcedureStaff, procedure_staff, available_staff, activeProcedureID,getStaffArchive,staff_archive,}) => {
    const [idtoEdit, setIdEdit] = useState(null)
    const inputStaffId = useRef(null)
    const [modal, setModal] = useState(false);
    const toggle =()=>setModal(!modal)
    const valueConvert = (val) => {
        let nr = Number(val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".", ",")
        return nr === "NaN" ? " X " : nr
    }
    const [formValues, setFormValues] = useState({
        staff_name: "",
        "unit_price": "0",
        'time_unit': "minuta",
        how_many_per_proc: 0,
        "number_of_procedures": '0',
        wklad: "0",
        staff_id:null
    })
    const [formValuesEdit, setFormValuesEdit] = useState({
        id: '',
        staff_name_edit: "",
        unit_price_edit: "",
        time_unit_edit: "",
        'how_many_per_proc_edit': "",
        "number_of_procedures_edit": '',
        wklad_edit: "",
        staff_id_edit:null

    })
    const [personalName,setPersonalName] = useState({value:"",label:""})
    const [personalNameEdit,setPersonalNameEdit] = useState({value:"",label:""})
    useEffect(() => {
        if (available_staff.length > 0) {
            const newItem = available_staff[0]
            // if (newItem) {
            //     setFormValues((prevState) => {
            //         const prevLoginValues = {...prevState};
            //         prevLoginValues.staff_name = newItem.staff_name;
            //         if (prevLoginValues.time_unit === undefined) {
            //             prevLoginValues.unit_price = newItem.rate_min;
            //         }
            //         if (prevLoginValues.time_unit === "minuta") {
            //             prevLoginValues.unit_price = newItem.rate_min;
            //         }
            //         if (prevLoginValues.time_unit === "procedura") {
            //             prevLoginValues.unit_price = newItem.rate_proc;
            //         }
            //         if (prevLoginValues.time_unit === "godzina") {
            //             prevLoginValues.unit_price = newItem.rate_hour;
            //         }
            //         return prevLoginValues;
            //     });
            // }

        }


    }, [])
    const handleFieldChange = (e) => {
        const fieldValue = e.target.value;
        const fieldIndex = e.target.id

        setFormValues((prevState) => {
            const prevLoginValues = {...prevState};
            prevLoginValues[fieldIndex] = fieldValue;
            return prevLoginValues;
        });
    }
    const handleEdit = (e) => {
        const fieldValue = e.target.value;
        const fieldIndex = e.target.id;
        setFormValuesEdit((prevState) => {
            const prevLoginValues = {...prevState};
            prevLoginValues[fieldIndex] = fieldValue;
            return prevLoginValues;
        });
    }
    const seIdelement = (elem) => {
        const newItem = available_staff.filter(key => key.staff_name === elem.staff_name)[0];
        if(newItem){
        // getStaffArchive(newItem.id)
        let temp = {
            id: elem.id,
            staff_name_edit: elem.staff_name,
            unit_price_edit: elem.unit_price,
            'time_unit_edit': elem.time_unit,
            'how_many_per_proc_edit': elem.how_many_per_proc,
            number_of_procedures_edit: elem.number_of_procedures,
            "wklad_edit": elem.wklad,
            procedure_staff_edit:elem.procedure_staff

        }
        if (temp.time_unit === "minuta") {
            temp.unit_price = newItem.rate_min;
        }
        if (temp.time_unit === "procedura") {
            temp.unit_price = newItem.rate_proc;
        }
        if (temp.time_unit === "godzina") {
            temp.unit_price = newItem.rate_hour;
        }
        if (temp.unit_price == "" || temp.unit_price == null)
            temp.unit_price = 0
        setIdEdit(elem.id, setFormValuesEdit(temp))
        setPersonalNameEdit({value:elem.staff_name,label:elem.staff_name})
    }
    }
    const addStaff = (e) => {

        e.preventDefault();

         const name = formValues.staff_name.split('-')[0]
        // formValues.procedure_staff = available_staff.filter(key => key.staff_name === name);
        if (formValues.procedure_staff  && activeProcedureID && parseFloat(formValues.how_many_per_proc) > 0 && parseFloat(formValues.number_of_procedures) > 0) {

            // if(formValues.procedure_staff[0]){formValues.procedure_staff = formValues.procedure_staff[0].id}else{formValues.procedure_staff=null}
            formValues.procedure_staffcalc = activeProcedureID
            formValues.staff_name = name

            postProcedureStaff(formValues)
            setFormValues(({
                how_many_per_proc: 0,
                "number_of_procedures": '0',
                wklad: "0",
            }))
            changeAddItem(personalName)
        }
    }

    const sumbitEdit = (e, id) => {
        e.preventDefault();
        Object.keys(formValuesEdit).map(key => delete Object.assign(formValuesEdit, {[key.replace("_edit", "")]: formValuesEdit[key]})[key])
        formValuesEdit.id = id;
        // if(available_staff.filter(key => key.staff_name === formValuesEdit.staff_name)[0]) {formValuesEdit.procedure_staff = available_staff.filter(key => key.staff_name === formValuesEdit.staff_name)[0].id}
        // else{formValuesEdit.procedure_staff =null}
        editProcedureStaff(formValuesEdit)
    };
    const changeEditedItem = (e, elem) => {
        const newItem = available_staff.filter(key => key.staff_name === e.value)[0]
        if (newItem) {
            setFormValuesEdit((prevState) => {
                const prevLoginValues = {...prevState};
                prevLoginValues.rate_proc_edit=newItem.rate_proc
                prevLoginValues.rate_min_edit=newItem.rate_min
                prevLoginValues.rate_hour_edit=newItem.rate_hour
                prevLoginValues.staff_name_edit = newItem.staff_name;
                if (prevLoginValues.time_unit_edit === "minuta") {
                    prevLoginValues.unit_price_edit = newItem.rate_min;
                }
                if (prevLoginValues.time_unit_edit === "procedura") {
                    prevLoginValues.unit_price_edit = newItem.rate_proc;
                }
                if (prevLoginValues.time_unit_edit === "godzina") {
                    prevLoginValues.unit_price_edit = newItem.rate_hour;
                }
                if (prevLoginValues.unit_price == "" || prevLoginValues.unit_price == null)
                    prevLoginValues.unit_price = 0
                prevLoginValues.how_many_per_proc_edit = elem.how_many_per_proc;
                prevLoginValues.number_of_procedures_edit = elem.number_of_procedures;
                prevLoginValues.wklad_edit = elem.wklad;

                prevLoginValues.staff_id_edit = newItem.id
                prevLoginValues.procedure_staff_edit = newItem.id

                setPersonalNameEdit({value:newItem.staff_name,label:newItem.staff_name})
                return prevLoginValues;
            });
        }
    }

    const changeEditedStaffTime = (e, id, item_id) => {
        const newItem = available_staff.filter(key => key.staff_name === item_id)[0]
        const fieldValue = e.target.value;
        const fieldIndex = id;
        if(formValuesEdit.rate_hour_edit || formValuesEdit.rate_proc_edit) {const archive = formValuesEdit; 
        setFormValuesEdit((prevState) => {
            
            const prevLoginValues = {...prevState};
            prevLoginValues[fieldIndex] = fieldValue;

            if (prevLoginValues.time_unit_edit === "minuta") {
                prevLoginValues.unit_price_edit = archive.rate_min_edit;
            };
            if (prevLoginValues.time_unit_edit === "procedura") {
                prevLoginValues.unit_price_edit = archive.rate_proc_edit;
            }
            if (prevLoginValues.time_unit_edit === "godzina") {
                prevLoginValues.unit_price_edit = archive.rate_hour_edit;
            }
            if (prevLoginValues.unit_price_edit == "" || prevLoginValues.unit_price_edit == null || prevLoginValues.unit_price_edit == NaN || prevLoginValues.unit_price_edit == 'NaN')
                    prevLoginValues.unit_price_edit = 0
            return prevLoginValues;
            
        })
    return 0}
        if(newItem){
        setFormValuesEdit((prevState) => {
            
            const prevLoginValues = {...prevState};
            prevLoginValues[fieldIndex] = fieldValue;
            if (prevLoginValues.time_unit_edit === "minuta") {
                prevLoginValues.unit_price_edit = newItem.rate_min;
            }
            if (prevLoginValues.time_unit_edit === "procedura") {
                prevLoginValues.unit_price_edit = newItem.rate_proc;
            }
            if (prevLoginValues.time_unit_edit === "godzina") {
                prevLoginValues.unit_price_edit = newItem.rate_hour;
            }
            if (prevLoginValues.unit_price == "" || prevLoginValues.unit_price == null)
                    prevLoginValues.unit_price = 0
            return prevLoginValues;
        });
    }
    }


    const changeAddStaffTime = (e, id) => {
        const fieldValue = e.target.value;
        const name = formValues.staff_name.split('-')[0]
        if(formValues.rate_hour || formValues.rate_proc) {const archive = formValues; 
        setFormValues((prevState) => {
            
            const prevLoginValues = {...prevState};
            prevLoginValues[id] = fieldValue;

            if (prevLoginValues.time_unit === "minuta") {
                prevLoginValues.unit_price = archive.rate_min;
            };
            if (prevLoginValues.time_unit === "procedura") {
                prevLoginValues.unit_price = archive.rate_proc;
            }
            if (prevLoginValues.time_unit === "godzina") {
                prevLoginValues.unit_price = archive.rate_hour;
            }
            if (prevLoginValues.unit_price == "" || prevLoginValues.unit_price == null || prevLoginValues.unit_price == NaN || prevLoginValues.unit_price == 'NaN')
                    prevLoginValues.unit_price = 0
            return prevLoginValues;
            
        })
    return 0}
        // const id = 
        const newItem = available_staff.filter(key => key.staff_name === name)[0]
        const fieldIndex = id;
        if(newItem){
        setFormValues((prevState) => {

            const prevLoginValues = {...prevState};
            prevLoginValues[fieldIndex] = fieldValue;
            if (prevLoginValues.time_unit === undefined) {
                prevLoginValues.unit_price = newItem.rate_min;
            }
            if (prevLoginValues.time_unit === "minuta") {
                prevLoginValues.unit_price = newItem.rate_min;
            }
            if (prevLoginValues.time_unit === "procedura") {
                prevLoginValues.unit_price = newItem.rate_proc;
            }
            if (prevLoginValues.time_unit === "godzina") {
                prevLoginValues.unit_price = newItem.rate_hour;
            }
            if (prevLoginValues.unit_price == "" || prevLoginValues.unit_price == null || prevLoginValues.unit_price == NaN || prevLoginValues.unit_price == 'NaN')
                    prevLoginValues.unit_price = 0
            return prevLoginValues;
        });
    }
    }


    const changeAddItem = (e) => {

        let newItem = null
        
        // if(e.target){
        if(e.value){
        const name = e.value.split('-')[0]
        const id = e.value.split('-')[1]
        newItem = available_staff.filter(key => key.id == id)[0]
        }
        // else if(e.props.value !== null) {
        //     const name = e.props.value.split('-')[0]
        //     const id = e.props.value.split('-')[1]
        //     newItem = available_staff.filter(key => key.id == id)[0]
        // }
        if (newItem) {
            setFormValues((prevState) => {
                const prevLoginValues = {...prevState};
                // if(prevLoginValues.hasOwnProperty('rate_proc')){delete prevLoginValues.rate_proc}
                // if(prevLoginValues.hasOwnProperty('rate_hour')){delete prevLoginValues.rate_hour}
                // if(prevLoginValues.hasOwnProperty('rate_min')){delete prevLoginValues.rate_min}
                prevLoginValues.rate_proc=newItem.rate_proc
                prevLoginValues.rate_min=newItem.rate_min
                prevLoginValues.rate_hour=newItem.rate_hour
                if (prevLoginValues.time_unit === undefined) {
                    prevLoginValues.unit_price = newItem.rate_min;
                    prevLoginValues.time_unit = "minuta";
                }
                if (formValues.time_unit === "minuta") {
                    prevLoginValues.unit_price = newItem.rate_min;
                }
                if (formValues.time_unit === "procedura") {
                    prevLoginValues.unit_price = newItem.rate_proc;
                }
                if (formValues.time_unit === "godzina") {
                    prevLoginValues.unit_price = newItem.rate_hour;
                }
                if (prevLoginValues.unit_price == "" || prevLoginValues.unit_price == null || prevLoginValues.unit_price == NaN || prevLoginValues.unit_price == 'NaN')
                    prevLoginValues.unit_price = 0
                prevLoginValues.staff_name = newItem.staff_name+"-"+newItem.id;
                prevLoginValues.wklad = newItem.wklad;
                prevLoginValues.staff_id = newItem.id
                prevLoginValues.procedure_staff = newItem.id
                return prevLoginValues;
            });
            setPersonalName({value:newItem.staff_name+"-"+newItem.id, label:newItem.staff_name})
        }
    }
    const showArchiveMat = (type) => {
        if(type==='new'){
            setIdEdit(null)
            getStaffArchive(formValues.staff_id)
            setModal(true)}
        else if(type==='edit'){
            getStaffArchive(formValuesEdit.procedure_staff_edit)
            setModal(true)
        }
    }
    const selectFromArchive = (material) => {
        if(!idtoEdit){
            setFormValues((prevState) => {
                const prevLoginValues = {...prevState};
                prevLoginValues.staff_name=material.staff_name ;
                prevLoginValues.unit_price= material.rate_min;
                prevLoginValues.time_unit= "minuta";
                prevLoginValues.rate_hour=material.rate_hour;
                prevLoginValues.rate_proc=material.rate_proc;
                prevLoginValues.rate_min=material.rate_min;
                // how_many_per_proc: 0,
                // "number_of_procedures": '0',
                // wklad: "0",
                prevLoginValues.staff_id=material.id
                prevLoginValues.procedure_staff=material.id
                if(material.rate_min == NaN || material.rate_min==null || material.rate_min=='NaN'){ prevLoginValues.unit_price= 0}
                return prevLoginValues;
            });

            // setPersonalName({value:material.staff_name, label:material.staff_name})
            setModal(false)}
            else{
                let temp = {
                    staff_name_edit:material.staff_name,
                    unit_price_edit: material.rate_min,
                    time_unit_edit: "minuta",
                    rate_hour_edit:material.rate_hour,
                    rate_proc_edit:material.rate_proc,
                    rate_min_edit:material.rate_min,
                    staff_id_edit:material.id,
                    // unit_price_edit: material.unit_price,
                    procedure_staff_edit:material.id,
                    
                }
                if(material.rate_min == NaN || material.rate_min==null || material.rate_min=='NaN'){ temp.unit_price= 0}
                // setMaterialNameEdit({value:material.name,label:material.name})
                setFormValuesEdit(temp)
                setModal(false)
            }
    }
    const getTableRow = (values, format={}, mergeCells={col:[], row: []}) => {
        let row = []
        values.forEach( (val, i) => {
          row.push(new TableCell({
            children: [
              new Paragraph({
                children: [new TextRun({ 
                  text: String(val), 
                  font:'Calibri', 
                  bold: format.bold||(format.firstBold&&i===0), 
                  color: format.textColor,
                  size: format.size,
                  allCaps: format.allCaps
                })],
                alignment: format.align[i]
              })
            ],
            rowSpan: mergeCells.row[i]?mergeCells.row[i]:1,
            columnSpan: mergeCells.col[i]?mergeCells.col[i]:1,
            verticalAlign: VerticalAlign.CENTER,
            shading: {
              fill: format.backgroundColor
            },
            margins: {
              marginUnitType: WidthType.DXA,
              top: 100, bottom: 100, left: 100, right: 100
            }
          }))
        })
        return row
      }
    const downloadDoc = () =>{
        let rows = []
        const headerStyle = {
          bold: true, backgroundColor:'#006ba7', textColor: 'white', size: '22', allCaps: true,
          align: Array(6).fill(AlignmentType.CENTER)
        }
        const bodyStyle = {
          bold: false, backgroundColor:'white', textColor: 'black', size: '24', allCaps: false,
          align: ([AlignmentType.LEFT, AlignmentType.RIGHT, AlignmentType.LEFT]).concat(Array(3).fill(AlignmentType.RIGHT))
        }
        //header
        rows.push(new TableRow({
            children: getTableRow([
                'Grupa personelu',
                'Liczba procedur',
                'Jednostka czasu',
                'Ilość jednostek czasu zużyta na realizację procedury',
                'Koszt Jednostki czasu',
                'Wkład do kosztu jednostkowego'
            ], headerStyle),
            tableHeader: true
        }))
        //body
        procedure_staff.map((elem, i) => {
          rows.push(new TableRow({
            children: getTableRow([
                elem.staff_name,
                valueConvert(elem.number_of_procedures),
                elem.time_unit,
                valueConvert(elem.how_many_per_proc),
                valueConvert(elem.unit_price),
                valueConvert(elem.wklad)
            ], bodyStyle)
          }))
        })

        rows.push(new TableRow({
            children: getTableRow([
                'Wartość ogółem',
                procedure_staff&&procedure_staff.length>0?valueConvert(procedure_staff.map(item => Number(item.wklad)).reduce((prev, next) => prev+next)):0
            ], bodyStyle, {col:[5,1], row: []})
        }))
    
        let table = new Table({
          rows: rows,
          width: { size: 100, type: WidthType.PERCENTAGE}
        })
    
        //DOCUMENT
        let paragraphs = [
          new Paragraph({
            children:[
              new TextRun({text: 'Tabela nakładu czasu pracy osób wykonujących procedurę'+'\n\n', font:'Calibri', bold: true, size: 26 })
            ],
            alignment: AlignmentType.JUSTIFIED,
            spacing: { after: 200 }
          }),
          table
        ]
    
        let doc = new Document({ 
          sections: [{
            properties: { page: { 
              margin: {
                  top: convertMillimetersToTwip(15),
                  right: convertMillimetersToTwip(15),
                  bottom: convertMillimetersToTwip(15),
                  left: convertMillimetersToTwip(15),
              },
            }},
            children: paragraphs
          }] 
        })
    
        // doc.Settings.addCompatibility().doNotExpandShiftReturn();
    
        Packer.toBlob(doc).then(blob =>{
          saveAs(blob, 'Tabela nakładu czasu pracy osób wykonujących procedurę.doc')
        })
    }
    const downloadCSV = () =>{
        let filename = "Tabela nakładu czasu pracy osób wykonujących procedurę"+'.csv';
        var tableSelect = document.getElementById('wycenaPersonel')
        var tableHTML = tableSelect.outerHTML;
        var csv = [];
        var rows = document.querySelectorAll(`#wycenaPersonel tr`);
        
        for (var i = 0; i < rows.length; i++) {
            var row = [], cols = rows[i].querySelectorAll("td, th");
            if(i==1){}
            else if(i==rows.length-1){row.push(cols[0].innerText); row.push(""); row.push("");row.push("");row.push("");row.push(cols[cols.length-2].innerText);csv.push(row.join(";"));}
            else {for (var j = 0; j < cols.length-1; j++) row.push(cols[j].innerText)
            csv.push(row.join(";"));		}}
            csv = csv.join("\n")

        var csvFile;
        var downloadLink;
        var universalBOM = "\uFEFF";
        csvFile = new Blob(['\ufeff',csv], {type: "text/csv;charset=UTF-8"});
        downloadLink = document.createElement("a");
        downloadLink.download = filename;
        downloadLink.href = window.URL.createObjectURL(csvFile);
        downloadLink.style.display = "none";
        document.body.appendChild(downloadLink);
        downloadLink.click(); 
    }
    const downloadXlsx = () =>{
        var wb = XLSX.utils.table_to_book(document.getElementById('wycenaPersonel'), {sheet:"wycena", raw:true});
        //
        var ws = wb.Sheets["wycena"];
        var range = XLSX.utils.decode_range(ws['!fullref']);
        // console.log(range.e.r)
        for(let i=1;i<=range.e.r+1;i++){
            if(i==1){delete ws[`G${i}`];}
         //  get the current sheet
         if(i==2) {delete ws[`A${i}`]; delete ws[`B${i}`];delete ws[`C${i}`];delete ws[`D${i}`];delete ws[`E${i}`];delete ws[`F${i}`];delete ws[`G${i}`]; delete ws[`H${i}`];delete ws[`I${i}`]; }
       
        // if(i==1) {delete ws} // delete old formatted text if it exists
    
        // console.log(ws[`D${i}`].w) // refresh cell
        
        }

        //
        var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});
        let filename = "Tabela nakładu czasu pracy osób wykonujących procedurę"+'.xlsx';
        saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), filename);
    }
    const s2ab = (s)=>{
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i=0; i<s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }

    return (
        <div className="content">
        <ReportButtons downloadDoc={downloadDoc} downloadCSV={downloadCSV} downloadXlsx={downloadXlsx} color='wycena'/>
            <table className='table table-border tableWycena' id="wycenaPersonel">
                <thead className=''>
                <tr className=''>
                    <th className="headerColor">Grupa personelu</th>
                    <th className="headerColor">Liczba procedur</th>
                    <th className="headerColor">Jednostka czasu</th>
                    <th className="headerColor">Ilość jednostek czasu zużyta na realizację procedury</th>
                    <th className="headerColor">Koszt Jednostki czasu</th>
                    <th className="headerColor">Wkład do kosztu jednostkowego
                    </th>
                    <th className="headerColor">Opcje
                    </th>
                </tr>
                </thead>
                <tbody>
                    <tr>
                        <td >
                            <div style={{display:"grid", gridTemplateColumns:"10fr 1fr"}}>
                                <div style={{width:"98%"}}><Select
                                    value={personalName}
                                    className="react-select select-wycena"
                                    classNamePrefix="react-select"
                                    onChange={(value)=>changeAddItem(value)}
                                    options={available_staff.map((key,i)=>{return {value:key.staff_name+"-"+key.id,label:key.staff_name}})}
                                /></div>
                                {formValues.staff_name && <>
                                    <i  class="far fa-folder-open" id="archAddPersonel" style={{alignSelf:"center", cursor:"pointer"}}  onClick={()=>{showArchiveMat('new')}}></i>
                                    <UncontrolledTooltip
                                        delay={{ show: 0, hide: 200 }}
                                        placement="bottom"
                                        target='archAddPersonel'
                                    >
                                        Pokaż archiwum
                                    </UncontrolledTooltip>
                                </>}
                            </div>
                        </td>
                        <td><Input
                            className="border-input"
                            type="number"
                            min='0'
                            id="number_of_procedures"
                            value={formValues['number_of_procedures']}
                            onChange={(e) => {
                                handleFieldChange(e)
                            }}
                        /></td>
                        <td>
                            <Input type="select" name="opk" id="opk_list"
                                    value={formValues['time_unit']}
                                    onChange={(e) => changeAddStaffTime(e, "time_unit")}>
                                <option value={'minuta'}>Minuty</option>
                                <option value={'godzina'}>Godziny</option>
                                <option value={'procedura'}>Procedura</option>
                            </Input>
                        </td>
                        <td><Input
                            className="border-input"
                            type="number"
                            min='0'
                            id="how_many_per_proc"
                            value={formValues['how_many_per_proc']}
                            onChange={(e) => {
                                handleFieldChange(e)
                            }}
                        /></td>
                        <td className='rightAlignCell'><Input
                            className="border-input"
                            type="text"
                            id="unit_price"
                            disabled={true}
                            value={parseFloat(formValues['unit_price']).toFixed(2).toString().replace('.',',')}
                        /></td>
                        <td> Obliczany po dodaniu pozycji </td>
                        <td className='text-center'>
                            <Button style={{width:"60px"}}
                                className="btn-round btn m-0"
                                color="wycena"
                                type="button"
                                onClick={(e) => addStaff(e)}
                                id={`add-new`}
                                outline
                            >
                                    <i className='nc-icon nc-simple-add'></i>
                                {/* <i className="far fa-plus-square fa-2x"></i> */}
                            </Button>
                            <UncontrolledTooltip
                                delay={0}
                                placement="top"
                                target={`add-new`}
                            >
                                Dodaj
                            </UncontrolledTooltip>
                        </td>
                    </tr>
                    {procedure_staff && procedure_staff.map((elem, i) => {
                        return <>
                            {idtoEdit !== elem.id ? <tr>
                                {/* EXISTING ENTRIES */}
                                <td className="">{elem.staff_name}</td>
                                <td className="rightAlignCell">{valueConvert(elem.number_of_procedures)}</td>
                                <td className="">{elem.time_unit}</td>
                                <td className="rightAlignCell">{valueConvert(elem.how_many_per_proc)}</td>
                                <td className="rightAlignCell">{valueConvert(elem.unit_price)}</td>
                                <td className="rightAlignCell">{valueConvert(elem.wklad)}</td>
                                {idtoEdit !== elem.id ? 
                                <td style={{whiteSpace: 'nowrap'}}>
                                    <EditButton idx={i} elem={elem} edit={seIdelement}/>
                                    <DeleteButton idx={i} id={elem.id} deleteFunc={deleteProcedureStaff} text={"koszt osboowy?"}/>
                                </td>: <td style={{whiteSpace: 'nowrap'}}> {/*UNUSED?*/}
                                    <span style={{marginRight: "5px", cursor: "pointer"}} onClick={() => { setIdEdit(null) }}>
                                    Anuluj</span>&nbsp;&nbsp;<span style={{marginLeft: "5px"}}>OK</span>
                                </td>}
                            </tr> : <tr>
                                {/* EDIT ENTRY */}
                                <td className="">
                                        <div style={{display:"grid", gridTemplateColumns:"10fr 1fr"}}>
                                        <div style={{width:'98%'}}><Select
                                            value={personalNameEdit}
                                            className="react-select select-wycena"
                                            classNamePrefix="react-select"
                                            onChange={(value)=>changeEditedItem(value,elem)}
                                            options={available_staff.map((key,i)=>{return {value:key.staff_name,label:key.staff_name}})}
                                        /></div>
                                        {formValuesEdit.staff_name_edit && <><i  className="far fa-folder-open" id="archEdit" style={{alignSelf:"center",cursor:"pointer"}} onClick={()=>{showArchiveMat('edit')}}></i>
                                        <UncontrolledTooltip
                                            delay={{ show: 0, hide: 200 }}
                                            placement="bottom"
                                            target='archEdit'
                                        >
                                            Pokaż archiwum
                                        </UncontrolledTooltip></>}</div>
                                </td>
                                <td>
                                    <Input
                                    className="border-input"
                                    type="number"
                                    min='0'
                                    id="number_of_procedures_edit"
                                    value={formValuesEdit['number_of_procedures_edit']}
                                    onChange={(e) => {
                                        handleEdit(e)
                                    }}
                                /></td>
                                <td>
                                    <Input type="select" name="opk" id="opk_list"
                                        value={formValuesEdit['time_unit_edit']}
                                        onChange={(e) => changeEditedStaffTime(e, "time_unit_edit", elem.staff_name)}>
                                        <option value={'minuta'}>Minuty</option>
                                        <option value={'godzina'}>Godziny</option>
                                        <option value={'procedura'}>Procedura</option>
                                    </Input>
                                </td>
                                <td>
                                    <Input
                                    className="border-input"
                                    type="number"
                                    min='0'
                                    id="how_many_per_proc_edit"
                                    value={formValuesEdit['how_many_per_proc_edit']}
                                    onChange={(e) => {
                                        handleEdit(e)
                                    }}

                                /></td>
                                <td className='rightAlignCell'>
                                    <Input
                                    className="border-input"
                                    type="text"
                                    id="unit_price_edit"
                                    disabled={true}
                                    value={parseFloat(formValuesEdit['unit_price_edit']).toFixed(2).toString().replace('.',',')}
                                /></td>
                                <td>
                                    {formValuesEdit.hasOwnProperty('wklad_edit') && (formValuesEdit['wklad_edit'] !== NaN || formValuesEdit['wklad_edit'] !== 'NaN')   ?<Input
                                    className="border-input"
                                    type="text"
                                    id="wklad_edit"
                                    disabled={true}
                                    value={parseFloat(formValuesEdit['wklad_edit']).toFixed(2).toString().replace('.',',')}
                                />:<>Wyliczony po zatwierdzeniu edycji</>}
                                </td>
                                <td style={{whiteSpace: 'nowrap'}}>
                                    <Button
                                        className="btn-link  m-0"
                                        color="success"
                                        data-toggle="tooltip"
                                        size="sm"
                                        type="button"
                                        id='check-edit'
                                        onClick={(e) => {
                                        sumbitEdit(e, idtoEdit);
                                        setIdEdit(null)
                                    }}
                                    >
                                        <i className="fas fa-check"></i>
                                    </Button>
                                    <UncontrolledTooltip delay={0} placement="top" target={`check-edit`} >
                                        Zapisz zmiany
                                    </UncontrolledTooltip>
                                    <Button
                                        className="btn-link  m-0"
                                        color="danger"
                                        data-toggle="tooltip"
                                        size="sm"
                                        type="button"
                                        id='cancel-edit'
                                        onClick={() => {
                                        setIdEdit(null)
                                    }}
                                    >
                                        <i className="fas fa-times"></i>
                                    </Button>
                                    <UncontrolledTooltip delay={0} placement="top" target={`cancel-edit`} >
                                        Odrzuć zmiany
                                    </UncontrolledTooltip>
                                </td>
                            </tr>}

                        </>
                    })}
                    <tr style={{fontWeight: 'bold'}}>
                        <td colSpan='5'>Wartość ogółem</td>
                        <td className='rightAlignCell'>
                            {procedure_staff&&procedure_staff.length>0?
                                valueConvert(procedure_staff.map(item => Number(item.wklad)).reduce((prev, next) => prev+next))
                            :0}
                        </td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
            <Modal isOpen={modal} toggle={toggle} size='xl'>
                <ModalHeader>Wszystkie zasoby osobowe dla wybranej grupy</ModalHeader>
                <ModalBody >
                    <table className='table table-border tableWycena'>
                        <thead className=''>
                            <tr className=''>
                                <th className="headerColor">GRUPA PERSONELU</th>
                                <th className="headerColor">Data obowiązywania</th>
                                <th className="headerColor">Stawka godzinowa w zł</th>
                                <th className="headerColor">Stawka za procedurę w zł</th>
                                <th className="headerColor">Opcje</th>
                            </tr>
                        </thead>
                        <tbody>
                            {staff_archive.length>0 && staff_archive.map((elem) =>  
                            <tr>
                                <td className="">{elem.staff_name}</td>
                                <td className="rightAlignCell">{elem.date_staff !=='1900.01.01' ? elem.date_staff:""}</td>
                                <td className="rightAlignCell">{parseFloat(elem.rate_hour).toFixed(2).toString().replace('.',',')}</td>
                                <td className="rightAlignCell">{parseFloat(elem.rate_proc).toFixed(2).toString().replace('.',',')}</td>
                                <td className="rightAlignCell"><Button color="wycena" outline className='btn-round' onClick={()=>{selectFromArchive(elem)}} >Wybierz</Button></td>
                            </tr>)}
                        </tbody>
                    </table>
                </ModalBody>
                <ModalFooter>
                    <Button style={{width:"100%"}} color="wycena" className="btn-link" onClick={toggle}>Zamknij</Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

// const mapStateToProps = state => ({
//     materials:state.procedureDefReducer.materials})
export default PersonalProcedurePricing
